import getShorterText from "Common/componentUtils/getShorterText";
export default {
    buildSummaryReportSavedSuccessfully: (name) => `Сводка "${getShorterText(name, 40)}" успешно сохранена`,
    buildSummaryReportSavingFailed: (name) => `Не удалось сохранить сводку "${getShorterText(name, 40)}"`
};
